var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container view-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("orderNewPatch.Information")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              !_vm.isView
                ? [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onConfirm },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("backText")))]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-position": "top",
            rules: _vm.rules,
            "label-width": "160px",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("orderNewPatch.CustomerOrder"),
                        prop: "orderBaseInfoDTO.outerOrderNo",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: "",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.orderBaseInfoDTO.outerOrderNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBaseInfoDTO,
                              "outerOrderNo",
                              $$v
                            )
                          },
                          expression: "form.orderBaseInfoDTO.outerOrderNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjSelectChannelStore", {
                attrs: {
                  span: _vm.colSpan,
                  disabled: "",
                  "query-params": _vm.form.orderBaseInfoDTO,
                  "query-keys": ["channel", "storeCode"],
                  "query-props": [
                    "orderBaseInfoDTO.channel",
                    "orderBaseInfoDTO.storeCode",
                  ],
                  "query-labels": [
                    _vm.$t("SalesOrderEntry.channel"),
                    _vm.$t("SalesOrderEntry.store"),
                  ],
                  "store-option-value": "code",
                },
                on: { handleStoreChange: _vm.onChangeStore },
              }),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseOrder2.means"),
                        prop: "orderBaseInfoDTO.shippingMethod",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.CSG_ORDER_SHIPPING_METHODS_LIST,
                        },
                        on: { change: _vm.onChangeShippingMethod },
                        model: {
                          value: _vm.form.orderBaseInfoDTO.shippingMethod,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBaseInfoDTO,
                              "shippingMethod",
                              $$v
                            )
                          },
                          expression: "form.orderBaseInfoDTO.shippingMethod",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("orderNewPatch.Ordered"),
                        prop: "orderBaseInfoDTO.orderTime",
                      },
                    },
                    [
                      _c("BjDateTimerPicker", {
                        model: {
                          value: _vm.form.orderBaseInfoDTO.orderTime,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBaseInfoDTO,
                              "orderTime",
                              $$v
                            )
                          },
                          expression: "form.orderBaseInfoDTO.orderTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SalesOrderEntry.Notes"),
                        prop: "orderBaseInfoDTO.orderRemarks",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.PRIORITY,
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          placeholder: _vm.$t("SalesOrderEntry.Notes"),
                        },
                        model: {
                          value: _vm.form.orderBaseInfoDTO.orderRemarks,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBaseInfoDTO,
                              "orderRemarks",
                              $$v
                            )
                          },
                          expression: "form.orderBaseInfoDTO.orderRemarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isCSGShow
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan / 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "WarehouseManagement.form.isQuotation"
                            ),
                            prop: "isQuota",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#082dc3",
                              "inactive-color": "",
                            },
                            model: {
                              value: _vm.isQuota,
                              callback: function ($$v) {
                                _vm.isQuota = $$v
                              },
                              expression: "isQuota",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isCSGShow
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan / 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "WarehouseManagement.form.isLogisticsSpecified"
                            ),
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              disabled: "",
                              "active-color": "#082dc3",
                              "inactive-color": "",
                            },
                            model: {
                              value: _vm.isLogisticsSpecified,
                              callback: function ($$v) {
                                _vm.isLogisticsSpecified = $$v
                              },
                              expression: "isLogisticsSpecified",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isLogisticsSpecified
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "WarehouseManagement.form.chooseLogistics"
                            ),
                            prop: "LogisticsSelectionDataRule",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.LogisticsSelectionData,
                            },
                            on: { change: _vm.logsome },
                            model: {
                              value:
                                _vm.form.orderBaseInfoDTO.logisticsBusinessName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.orderBaseInfoDTO,
                                  "logisticsBusinessName",
                                  $$v
                                )
                              },
                              expression:
                                "form.orderBaseInfoDTO.logisticsBusinessName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isCSGShow
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessThirdOrderAdd.deliveryAppointmentTime"
                            ),
                          },
                        },
                        [
                          _c("BjDateTimerPicker", {
                            model: {
                              value:
                                _vm.form.orderBaseInfoDTO
                                  .deliveryAppointmentTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.orderBaseInfoDTO,
                                  "deliveryAppointmentTime",
                                  $$v
                                )
                              },
                              expression:
                                "form.orderBaseInfoDTO.deliveryAppointmentTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isCustomerShow
                ? [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "WarehouseManagement.form.chooseLogistics"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.LogisticsSelectionData,
                              },
                              on: { change: _vm.logsome },
                              model: {
                                value:
                                  _vm.form.orderBaseInfoDTO
                                    .logisticsBusinessName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.orderBaseInfoDTO,
                                    "logisticsBusinessName",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.orderBaseInfoDTO.logisticsBusinessName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "OrdinaryOrderMix.LogisticsTable.logisticsNo"
                              ),
                              prop: "orderBaseInfoDTO.logisticsNo",
                            },
                          },
                          [
                            _c("BjInput", {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.orderBaseInfoDTO.logisticsNo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.orderBaseInfoDTO,
                                    "logisticsNo",
                                    $$v
                                  )
                                },
                                expression: "form.orderBaseInfoDTO.logisticsNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("WarehouseManagement.form.need"),
                              prop: "palletQty",
                            },
                          },
                          [
                            _c("BjInputNumber", {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.orderBaseInfoDTO.palletQty,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.orderBaseInfoDTO,
                                    "palletQty",
                                    $$v
                                  )
                                },
                                expression: "form.orderBaseInfoDTO.palletQty",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("WarehouseManagement.form.time"),
                              prop: "truckPickupTime",
                            },
                          },
                          [
                            _c("BjDateTimerPicker", {
                              model: {
                                value:
                                  _vm.form.orderBaseInfoDTO.truckPickupTime,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.orderBaseInfoDTO,
                                    "truckPickupTime",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.orderBaseInfoDTO.truckPickupTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("WarehouseManagement.form.check"),
                              prop: "isProvideSize",
                            },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-color": "#082dc3",
                                "inactive-color": "",
                              },
                              model: {
                                value: _vm.form.orderBaseInfoDTO.isProvideSize,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.orderBaseInfoDTO,
                                    "isProvideSize",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.orderBaseInfoDTO.isProvideSize",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-row",
            [
              [
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isCustomerShow,
                        expression: "isCustomerShow",
                      },
                    ],
                    attrs: { span: _vm.colSpan },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "OrdinaryOrderMix.LogisticsTable.Shipment"
                          ),
                        },
                      },
                      [
                        _c(
                          "UploadFile",
                          {
                            ref: "UploadFileRef1",
                            staticClass: "avatar-uploader",
                            attrs: {
                              limit: 20,
                              "limit-size": 5 * 1024,
                              multiple: "",
                              "show-file-list": "",
                              accept:
                                "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                              "accept-list": [
                                "image/jpeg",
                                "image/png",
                                ".csv",
                                ".pdf",
                                ".doc",
                                ".xlsx",
                              ],
                              "auto-upload": "",
                              "limit-hide": "",
                            },
                            on: { handleFileListChange: _vm.fileListChange1 },
                          },
                          [
                            _c(
                              "template",
                              { slot: "default" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "small", type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessImportHistory.page.SelectFile"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("template", { slot: "tip" }, [
                              _c("div", { staticClass: "hint" }, [
                                _c("p", [
                                  _vm._v(
                                    " 1." +
                                      _vm._s(
                                        _vm.$t(
                                          "OrdinaryOrderMix.LogisticsTable.ps1"
                                        )
                                      )
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " 2." +
                                      _vm._s(
                                        _vm.$t(
                                          "OrdinaryOrderMix.LogisticsTable.ps2"
                                        )
                                      )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "OrdinaryOrderMix.LogisticsTable.Supporting"
                          ),
                        },
                      },
                      [
                        _c(
                          "UploadFile",
                          {
                            ref: "UploadFileRef2",
                            staticClass: "avatar-uploader",
                            attrs: {
                              disabled: !_vm.$store.getters.cusId,
                              limit: 20,
                              "limit-size": 5 * 1024,
                              multiple: "",
                              "show-file-list": "",
                              accept:
                                "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                              "accept-list": [
                                "image/jpeg",
                                "image/png",
                                ".csv",
                                ".pdf",
                                ".doc",
                                ".xlsx",
                              ],
                              "auto-upload": "",
                              "limit-hide": "",
                            },
                            on: { handleFileListChange: _vm.fileListChange2 },
                          },
                          [
                            _c(
                              "template",
                              { slot: "default" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.$store.getters.cusId,
                                      size: "small",
                                      type: "primary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessImportHistory.page.SelectFile"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("template", { slot: "tip" }, [
                              _c("div", { staticClass: "hint" }, [
                                _c("p", [
                                  _vm._v(
                                    " 1." +
                                      _vm._s(
                                        _vm.$t(
                                          "OrdinaryOrderMix.LogisticsTable.ps3"
                                        )
                                      )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("orderNewPatch.Receiver")))]),
          _c(
            "el-row",
            [
              !_vm.cptIsPickSelf
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SalesOrderEntry.Consignee"),
                            prop: "orderBuyerInfoDTO.receiverName",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                            },
                            model: {
                              value: _vm.form.orderBuyerInfoDTO.receiverName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.orderBuyerInfoDTO,
                                  "receiverName",
                                  $$v
                                )
                              },
                              expression: "form.orderBuyerInfoDTO.receiverName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.cptIsPickSelf
                          ? _vm.$t("SalesOrderEntry.phone")
                          : _vm.$t("SalesOrderEntry.mobile"),
                        prop: "orderBuyerInfoDTO.deliveryPhone",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          onkeyup:
                            "this.value = this.value.replace(/[^\\d]/g,'');",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.orderBuyerInfoDTO.deliveryPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBuyerInfoDTO,
                              "deliveryPhone",
                              $$v
                            )
                          },
                          expression: "form.orderBuyerInfoDTO.deliveryPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ExternalOrders.newAdd.emailAddress"),
                        prop: "orderBuyerInfoDTO.deliveryEmailAddress",
                        rules: {
                          required: false,
                          validator: this.validatorEmail,
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL_REMARK,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value:
                            _vm.form.orderBuyerInfoDTO.deliveryEmailAddress,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBuyerInfoDTO,
                              "deliveryEmailAddress",
                              $$v
                            )
                          },
                          expression:
                            "form.orderBuyerInfoDTO.deliveryEmailAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("WarehouseManagement.form.country"),
                        prop: "orderBuyerInfoDTO.country",
                        rules: {
                          required: true,
                          message: this.$t("chooseText"),
                          trigger: "change",
                        },
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.orderBuyerInfoDTO.country,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderBuyerInfoDTO, "country", $$v)
                          },
                          expression: "form.orderBuyerInfoDTO.country",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _vm.form.orderBaseInfoDTO.shippingMethod == "PICKUP" ||
                  [
                    "TW",
                    "HK",
                    "MO",
                    "SG",
                    "GB",
                    "IE",
                    "IL",
                    "IS",
                    "AE",
                    "MC",
                    "BH",
                    "VA",
                    "SZ",
                    "MV",
                    "NZ",
                    "SM",
                    "LI",
                    "AD",
                    "BS",
                  ].includes(_vm.form.orderBuyerInfoDTO.country)
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WarehouseManagement.form.state"),
                            prop: "orderBuyerInfoDTO.province",
                            rules: {
                              required: false,
                              message: this.$t("inputText"),
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                            },
                            model: {
                              value: _vm.form.orderBuyerInfoDTO.province,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.orderBuyerInfoDTO,
                                  "province",
                                  $$v
                                )
                              },
                              expression: "form.orderBuyerInfoDTO.province",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WarehouseManagement.form.state"),
                            prop: "orderBuyerInfoDTO.province",
                            rules: {
                              required: true,
                              validator: this.validatorAddress1,
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                            },
                            model: {
                              value: _vm.form.orderBuyerInfoDTO.province,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.orderBuyerInfoDTO,
                                  "province",
                                  $$v
                                )
                              },
                              expression: "form.orderBuyerInfoDTO.province",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("WarehouseManagement.form.city"),
                        prop: "orderBuyerInfoDTO.district",
                        rules: {
                          required:
                            _vm.form.orderBaseInfoDTO.shippingMethod == "PICKUP"
                              ? false
                              : true,
                          validator: this.validatorAddress1,
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.orderBuyerInfoDTO.district,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBuyerInfoDTO,
                              "district",
                              $$v
                            )
                          },
                          expression: "form.orderBuyerInfoDTO.district",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("WarehouseManagement.form.postcode"),
                        prop: "orderBuyerInfoDTO.zipCode",
                        rules: {
                          required:
                            _vm.form.orderBaseInfoDTO.shippingMethod == "PICKUP"
                              ? false
                              : true,
                          validator: this.validatorPostCode,
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.SHORT_NAME,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.orderBuyerInfoDTO.zipCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderBuyerInfoDTO, "zipCode", $$v)
                          },
                          expression: "form.orderBuyerInfoDTO.zipCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ExternalOrders.newAdd.DeliveryAddress1"),
                        prop: "orderBuyerInfoDTO.deliveryAddress1",
                        rules: {
                          required:
                            _vm.form.orderBaseInfoDTO.shippingMethod == "PICKUP"
                              ? false
                              : true,
                          validator: this.validatorAddress1,
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.orderBuyerInfoDTO.deliveryAddress1,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBuyerInfoDTO,
                              "deliveryAddress1",
                              $$v
                            )
                          },
                          expression: "form.orderBuyerInfoDTO.deliveryAddress1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ExternalOrders.newAdd.DeliveryAddress2"),
                        prop: "orderBuyerInfoDTO.deliveryAddress2",
                        rules: {
                          required:
                            _vm.form.orderBaseInfoDTO.shippingMethod == "PICKUP"
                              ? false
                              : false,
                          validator: this.validatorAddress2,
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("SalesOrderEntry.address"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderBuyerInfoDTO.deliveryAddress2,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderBuyerInfoDTO,
                              "deliveryAddress2",
                              $$v
                            )
                          },
                          expression: "form.orderBuyerInfoDTO.deliveryAddress2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "BjDivider",
            {
              scopedSlots: _vm._u([
                {
                  key: "button",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.SELECTED_BJ_EBC_ID.length == 0,
                            type: "danger",
                          },
                          on: { click: _vm.batchDelete },
                        },
                        [_vm._v(_vm._s(_vm.$t("SalesOrderEntry.delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.addGoodsDialog("dialogListOrdinarySku")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("SalesOrderEntry.ordinary")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.addGoodsDialog("dialogListPackAgeSku")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("SalesOrderEntry.package")))]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(_vm._s(_vm.$t("SalesOrderEntry.Product")) + " ")]
          ),
          _c("OrderItemTable", {
            ref: "OrderItemTable",
            attrs: {
              disabled: false,
              "is-show": !_vm.$store.getters.cusId,
              "is-true": false,
              "table-data": _vm.form.orderItemDTOList,
            },
            on: {
              "update:tableData": function ($event) {
                return _vm.$set(_vm.form, "orderItemDTOList", $event)
              },
              "update:table-data": function ($event) {
                return _vm.$set(_vm.form, "orderItemDTOList", $event)
              },
              delete: _vm.onDelete,
              "selection-change": _vm.handleSelectionChange,
            },
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogListOrdinarySku",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.skuDefault(
            _vm.$t("SalesOrderEntry.goods"),
            {
              defaultQuery: { setFlag: 0, status: [3, 4, 5] },
            }
          ),
          multiple: "",
        },
        on: { confirm: _vm.onAddGoodsDialogConfirm },
      }),
      _c("BjDialogList", {
        ref: "dialogListPackAgeSku",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.skuDefault(
            _vm.$t("SalesOrderEntry.Add"),
            {
              defaultQuery: { setFlag: 1, status: [3, 4, 5] },
            }
          ),
          multiple: "",
        },
        on: { confirm: _vm.onAddGoodsDialogConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }